import { render, staticRenderFns } from "./TaskArchived.vue?vue&type=template&id=2e4c69e0&scoped=true"
import script from "./TaskArchived.vue?vue&type=script&lang=js"
export * from "./TaskArchived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4c69e0",
  null
  
)

export default component.exports